// extracted by mini-css-extract-plugin
export default {"striped":"table-module--striped--35062","hideMobile":"table-module--hide-mobile--7d8ed"};